'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024 from "./presto.types$-Role-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_RolesView$$anon$47(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_RolesView$$anon$47 as $c_Lpresto_RolesView$$anon$47 };
$p = $c_Lpresto_RolesView$$anon$47.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RolesView$$anon$47;
/** @constructor */
function $h_Lpresto_RolesView$$anon$47() {
}
export { $h_Lpresto_RolesView$$anon$47 as $h_Lpresto_RolesView$$anon$47 };
$h_Lpresto_RolesView$$anon$47.prototype = $p;
$p.bh = (function(_$27) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sc_SeqOps__sortBy__F1__s_math_Ordering__O(_$27, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$28) => _$28.tZ)), $j_presto$002etypes$0024$002dRole$002dName$0024.$m_Lpresto_types$RoleName$().csc());
});
var $d_Lpresto_RolesView$$anon$47 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RolesView$$anon$47, "presto.RolesView$$anon$47", ({
  Qd: 1,
  H: 1
}));
export { $d_Lpresto_RolesView$$anon$47 as $d_Lpresto_RolesView$$anon$47 };
//# sourceMappingURL=presto.-Roles-View$$anon$47.js.map
